// extracted by mini-css-extract-plugin
export var dowloadpdf = "alternativeicon-module--dowloadpdf--01175";
export var sectionContainer = "alternativeicon-module--section-container--db9c0";